function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
//// CONTROLLER ////
export var AddNewDeliveryFolderDialogController =
/*#__PURE__*/
function () {
  _createClass(AddNewDeliveryFolderDialogController, null, [{
    key: "$inject",
    get: function get() {
      return ['$mdDialog', '$q', '$scope', '$timeout', 'DestinationResourceFactory', 'loginService'];
    }
  }]);

  function AddNewDeliveryFolderDialogController($mdDialog, $q, $scope, $timeout, DestinationResourceFactory, loginService) {
    _classCallCheck(this, AddNewDeliveryFolderDialogController);

    /* BINDABLE : INJECTS */
    Object.assign(this, {
      $mdDialog: $mdDialog,
      $q: $q,
      $scope: $scope,
      $timeout: $timeout,
      DestinationResourceFactory: DestinationResourceFactory,
      loginService: loginService
    });
    /* BINDABLE : DATA */

    /* EVENTS */
    //Register any event listeners
  }
  /* IMPLEMENTATION : BINDABLE */


  _createClass(AddNewDeliveryFolderDialogController, [{
    key: "cancel",
    value: function cancel() {
      var vm = this;
      vm.$mdDialog.cancel();
    }
  }, {
    key: "save",
    value: function save() {
      var vm = this;
      vm.$mdDialog.hide({
        destination: vm.selectedDestination,
        fileType: vm.fileType
      });
    }
  }, {
    key: "findDests",
    value: function findDests(searchTerm) {
      var vm = this;
      var deferred = vm.$q.defer();
      vm.DestinationResourceFactory.getAll({
        alias: searchTerm,
        accountId: vm.loginService.getSessionData().accountId
      }, function success(destinations) {
        deferred.resolve(destinations.data.rows);
      }, function failure(err) {
        deferred.resolve([]);
        console.debug(err);
      });
      return deferred.promise;
    }
    /* IMPLEMENTATION : PRIVATE */
    // All private methods should start with '_' in order to distinguish them

    /* INITIALIZATION */

  }, {
    key: "$onInit",
    value: function $onInit() {}
  }]);

  return AddNewDeliveryFolderDialogController;
}();